import type { InsertScimTokenMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertScimTokenDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertScimTokenInput = { expireInMonths: '6' | '12' | '24' };

export const useInsertScimToken = createMutationHook({
  name: 'insertScimToken',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.scim.issueToken.mutationOptions({ onSuccess }),
  mapInput: (variables: InsertScimTokenInput) => variables,
  invalidate: (trpc) => [trpc.frontend.scim.getConfig.queryKey()],
  mapResponse: (result: {
    keyId: string;
    orgKey: string;
    createdOn: string;
    expiresOn: string;
    status: 'active' | 'expired' | 'revoked';
    token: string;
  }): InsertScimTokenMutation => ({
    insert_scim_token: {
      __typename: 'ScimTokenOutput',
      keyId: result.keyId,
      orgKey: result.orgKey,
      token: result.token,
      createdOn: result.createdOn,
      expiresOn: result.expiresOn,
      status: result.status,
    },
  }),
  graphqlDocument: InsertScimTokenDocument,
  graphqlVariables: (variables: InsertScimTokenInput) => ({ ...variables }),
  evictFields: ['getScimConfig'],
});
